"use client";

import axios from "axios";

import { getUserApiUrl } from "@/shared/constants/apiUrlConstants";
import { EXTERNAL_URLS } from "@/shared/constants/externalUrls";

export async function reverseGeocode(lat: number, lon: number) {
  const response = await axios.get(EXTERNAL_URLS.reverseGeocode, {
    params: {
      format: "json",
      lat,
      lon,
      addressdetails: 1,
    },
    headers: { "Accept-Language": "en" },
  });

  return response.data;
}
export async function lookupPincode(pincode: string, signal?: AbortSignal) {
  const response = await axios.get(`${getUserApiUrl()}/places/pin`, {
    params: { pin: pincode },
    signal,
  });
  return response.data;
}

export async function lookupPincodeFallback(pincode: string, signal?: AbortSignal) {
  const response = await axios.get(`${getUserApiUrl()}/places/pincode-data`, {
    params: { pin: pincode },
    signal,
  });
  return response.data;
}
